import Splide from "@splidejs/splide";

export class BlockVehicleSlider {
  _dom = {
    slider: null,
    bar: null,
    prevButton: null,
    nextButton: null,
  };

  _splide = null;

  constructor(el) {
    if (!el) return;

    this._dom.slider = el;
    this._dom.sliderList = el.querySelector(".splide__list");
    this._dom.lastSlide = el.querySelector(".last-slide");
    this._dom.bar = el.querySelector(".splide__progress--bar");

    // Check if lastSlide and sliderList exist before appending
    if (this._dom.lastSlide && this._dom.sliderList) {
      this._dom.sliderList.appendChild(this._dom.lastSlide);
    }

    this._splide = new Splide(el, {
      perPage: 4,
      perMove: 1,
      trimSpace: false,
      pagination: false,
      arrows: true,
      arrowPath: 'M30.07 22.59L16.33 36.33L20 40L40 20L20 0L16.33 3.67L30.07 17.41L0 17.41L0 22.59L30.07 22.59z',
      omitEnd: true,
      autoplay: false,
      speed: 1000,
      fixedWidth: "28.6rem",
      gap: "3.2rem",
      updateOnMove: true,
      breakpoints: {
        767: {
          fixedWidth: "15.5rem",
          perPage: 2,
          gap: "1.6rem",
        },
      },
    });

    this._splide.on("mounted", () => {
      this._initListeners();
    });

    this._splide.mount();

    if (this._dom.bar) {
      this._progress();
    }
  }

  _progress = () => {
    this._dom.end = this._splide.Components.Controller.getEnd() + 1;
    this._dom.rate = Math.min((this._splide.index + 1) / this._dom.end, 1);
    this._dom.bar.style.width = String(100 * this._dom.rate) + "%";
  };

  _initListeners() {
    // Updates the bar width whenever the carousel moves:
    if (this._dom.bar) {
      this._splide.on("mounted move", this._onMountedMove);
    }
  }

  _onMountedMove = () => {
    this._progress();
  };
}
